import { useCallback } from 'react'
import { useCreateApiNotification } from 'civic-champs-shared/api/hooks'
import { Action } from 'civic-champs-shared/api/hooks/useRemoteCollection'
import { AddressType, OrganizationLocationReporting } from 'locations/types'
import useUpdateNonSchedulableOpportunity from 'volunteering/opportunities/hooks/useUpdateNonSchedulableOpportunity'
import { OpportunityPayload } from 'Event/interfaces'

export const useEndOpportunityFromLocations = (
  replace?: Action<OrganizationLocationReporting>,
  showNotification = true,
  eager = true,
) => {
  const createNotification = useCreateApiNotification()
  const [updateOpportunity] = useUpdateNonSchedulableOpportunity(false) as [
    (opportunity: Partial<OpportunityPayload>, encodedOccurrence: string) => Promise<any>,
  ]

  return useCallback(
    async (location: OrganizationLocationReporting) => {
      let undo
      if (eager) {
        undo = replace?.({ ...location, timesUsedActive: 0, encodedOccurrence: null, type: AddressType.Event })
      }
      const notification = showNotification ? createNotification('Removing locations') : undefined
      try {
        await updateOpportunity(
          {
            geofencing: location.geofencing,
            startsAt: location.startsAt as string,
            name: location.name as string,
            endsAt: new Date(),
          },
          location.encodedOccurrence as string,
        )
        notification?.onSuccess('Location removed!')
        if (!eager) {
          replace?.({ ...location, timesUsedActive: 0, encodedOccurrence: null, type: AddressType.Event })
        }
      } catch (error) {
        notification?.onError(`Could not remove ${location.name || 'selected'} location`, error)
        undo?.()
      }
    },
    [createNotification, replace, eager, showNotification, updateOpportunity],
  )
}

export default useEndOpportunityFromLocations
